module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jxqvR"))).then(() => parcelRequire('hEqeo'));